export const properties=()=>{
    return  {
        COTIZA_EDUCACION: "https://api-dot-gnp-portalcorporativo-pro.appspot.com/cotizaEducacion",
        API_KEY:"AIzaSyBxt1g4td8AG1jOq44Dw9YwUC0qs52SsII",
        CORREOS_FROM: "educacion@gnp.com.mx",
        CORREO_ENDPOINT: "https://us-central1-gnp-portalcorporativo-pro.cloudfunctions.net/EnviarMail"
    };
}




// WEBPACK FOOTER //
// ./src/properties/properties.js